<template>
  <div class="chart">
    <div class="simple" v-if="simpleData">
      <h3 class="title">
        <span>店铺指标</span>
        <el-button
          size="mini"
          @click="settingLayer=true"
          style="margin-left:50px;">
          设置
        </el-button>
        <el-button
          size="mini"
          type="primary"
          @click="refresh"
          style="margin-left:20px;">
          刷新
        </el-button>
      </h3>
      <el-row :gutter="12">
        <el-col
          class="simple-item"
          :span="4"
          v-for="(item,index) in settings"
          :key="index"
          v-if="item.is_show">
          <el-card shadow="hover">
            <p class="strong" v-if="item.type==='money'">
              <span class="small gray">￥</span>{{simpleData[item.key]/100}}
            </p>
            <p class="strong" v-else>{{simpleData[item.key]}}</p>
            <p class="gray small">{{item.label}}</p>
          </el-card>
        </el-col>
      </el-row>
    </div>
    <div class="pie" v-if="pieData.city">
      <h3 class="title">访客分布</h3>
      <div class="pie-container">
        <div class="pie-item">
          <h4>省份</h4>
          <ve-pie
            :data="pieData['province'].pieChartData"
            :settings="pieData['province'].pieChartSettings"
            height="300px">
          </ve-pie>
        </div>
        <div class="pie-item">
          <h4>城市</h4>
          <ve-pie :data="pieData['city'].pieChartData" :settings="pieData['city'].pieChartSettings"></ve-pie>
        </div>
        <div class="pie-item">
          <h4>性别</h4>
          <ve-pie :data="pieData['gender'].pieChartData" :settings="pieData['gender'].pieChartSettings"></ve-pie>
        </div>
        <div class="pie-item">
          <h4>来源</h4>
          <ve-pie :data="pieData['client_type'].pieChartData" :settings="pieData['client_type'].pieChartSettings"></ve-pie>
        </div>
        <div class="pie-item">
          <h4>浏览页面</h4>
          <ve-pie :data="pieData['page_type'].pieChartData" :settings="pieData['page_type'].pieChartSettings"></ve-pie>
        </div>
      </div>
    </div>
    <div class="line" v-if="lineChartData">
      <h3 class="title">
        <span>流量走势</span>
        <p class="time-filter">
          <el-button-group>
            <el-button
              size="mini"
              :type="lineUrl==='hour-polyline'?'primary':''"
              @click="getLine('hour-polyline')">
              今天
            </el-button>
            <el-button
              size="mini"
              :type="lineUrl==='month-polyline'?'primary':''"
              @click="getLine('month-polyline')">
              近30天
            </el-button>
          </el-button-group>
          <el-date-picker
            v-model="date"
            size="mini"
            type="date"
            placeholder="选择日期"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
            @change="getLine('hour-polyline',$event)"
            :picker-options="pickerOptions">
          </el-date-picker>
        </p>
      </h3>
      <ve-line :data="lineChartData" :settings="lineChartSettings" style="width:98%;"></ve-line>
    </div>
    <mask-layer v-show="settingLayer" v-model="settingLayer">
      <div class="setting-content">
        <h3>设置</h3>
        <el-row :gutter="12">
          <draggable class="draggable" v-model="settings">
            <el-col
              class="simple-item item"
              v-for="(item,index) in settings"
              :key="index"
              :span="6">
              <el-card shadow="hover" class="setting-item">
                <div class="left">
                  <p class="strong">{{simpleData[item.key]}}</p>
                  <p class="gray small">{{item.label}}</p>
                </div>
                <el-switch
                  class="switch"
                  v-model="item.is_show">
                </el-switch>
              </el-card>
            </el-col>
          </draggable>
        </el-row>
      </div>
    </mask-layer>
  </div>
</template>
<script>
import MaskLayer from '@/components/MaskLayer'
import request from '@/utils/request'
import draggable from 'vuedraggable'

export default {
  name: 'chart',
  components: {
    MaskLayer,
    draggable
  },
  data () {
    return {
      settingLayer: false,
      settings: [],
      simpleData: '',
      pieData: {},
      lineChartData: '',
      lineChartSettings: {},
      lineUrl: '',
      date: '',
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      },
      map: [
        {
          key: 'customer',
          label: '当天顾客数',
          is_show: true
        },
        {
          key: 'customer_yestoday',
          label: '昨天顾客数',
          is_show: true
        }
      ]
    }
  },
  watch: {
    settings: {
      handler () {
        if (this.settingLayer === false) {
          return
        }
        request({
          url: 'setting/index-data-card',
          method: 'put',
          data: {
            setting: this.settings
          }
        }).then(res => {
        })
      },
      deep: true
    }
  },
  created () {
    this.refresh()
    request({
      url: 'setting/index-data-card',
      method: 'get'
    }).then(res => {
      this.settings = res.data.setting
    })
  },
  methods: {
    refresh () {
      this.getPie()
      this.getLine('hour-polyline')
      this.getSimple()
    },
    getPie (date) {
      request({
        url: 'stat/visitor-pies',
        method: 'get'
      }).then(res => {
        let data = res.data.pies
        for (let key in data) {
          this.pieData[key] = data[key]
          this.pieData[key].pieChartData = {
            columns: ['label', 'value'],
            rows: res.data.pies[key],
            center: ['50%', '30%']
          }
          this.pieData[key].pieChartSettings = {
            radius: 60
          }
        }
      })
    },
    getLine (url, date) {
      let sendData = ''
      if (date) {
        this.lineUrl = ''
        sendData = {
          date
        }
      } else {
        this.lineUrl = url
        this.date = ''
      }
      request({
        url: 'stat/' + url,
        method: 'get',
        params: sendData
      }).then(res => {
        let data = res.data.stat
        let rows = []
        data.forEach(item => {
          item.value.label = item.label
          rows.push(item.value)
        })
        this.lineChartData = {
          columns: ['paid', 'pv', 'uv'],
          rows: rows
        }
        this.lineChartSettings = {
          metrics: ['paid', 'pv', 'uv'],
          dimension: ['label'],
          labelMap: {
            paid: '支付订单',
            pv: '浏览量',
            uv: '访客'
          },
          nullAddZero: true
        }
      })
    },
    getSimple () {
      request({
        url: 'stat/simple-data',
        method: 'get'
      }).then(res => {
        this.simpleData = res.data
      })
    }
  }
}
</script>
<style lang="less" scoped>
@height: 40px;
.chart {
  min-width: 900px;
  .strong {
    font-size: 20px;
    color: #000000;
    .small {
      font-size: 12px;
    }
  }
  .simple {
    .simple-item {
      margin-bottom: 10px;
    }
  }
  .title {
    height: @height;
    line-height: @height;
    background-color: #F2F6FC;
    font-size: 14px;
    color: #444444;
    padding-left: 18px;
    position: relative;
    margin-bottom: 10px;
    .time-filter {
      font-weight: normal;
      color: #999999;
      display: inline-block;
      margin-left: 50px;
    }
    &::before {
      content: '';
      width: 3px;
      height: 20px;
      background-color: #409EFF;
      position: absolute;
      top: 10px;
      left: 8px;
    }
  }
  .pie-container {
    display: flex;
    flex-wrap: wrap;
    .pie-item {
      width: 250px;
      margin-left: 30px;
      h4 {
        text-align: center;
        padding: 8px 0;
      }
    }
  }
  .setting-content {
    width: 1100px;
    h3 {
      text-align: center;
      margin-bottom: 20px;
    }
    padding: 20px 40px!important;
    .simple-item {
      margin-bottom: 10px;
      .setting-item {
        position: relative;
        .switch {
          position: absolute;
          right: 10px;
          top: 40%;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/index/chart.vue